export enum PerfilEnum{
    INTERNAUTA = 0,
    ADMINISTRADOR = 1,
    ESPECIALISTA = 2
}